"use client";

import React, { ReactNode } from "react";
import styled from "styled-components";
import { Box } from "@motorata/base-ui.components.atoms._atoms";
import NewsletterSection from "@/components/sections/NewsletterSection";
import RentSection from "@/components/sections/RentSection";
import AdvantagesSection from "@/components/sections/AdvantagesSection";
import FooterSection from "@/components/shared/FooterSection";

export default function OfferTemplate({ children }: {
  children: ReactNode
}) {

  return (
    <Wrapper>
      {children}
      <RentSection />
      <FooterSection>
        <AdvantagesSection />
        <NewsletterSection />
      </FooterSection>
    </Wrapper>
  );
}


const Wrapper = styled(Box)`
  max-width: 1300px;
  margin: 0 auto;
`;
